module.exports = __webpack_public_path__ + "img/background.04b2769b.jpg";